import { Link } from 'react-router-dom';
import { kaspreadsheetUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Hero background - completely unique image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20modern%20workspace%20with%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%20onto%20a%20clean%20white%20desk%20with%20a%20laptop%20showing%20colorful%20spreadsheet%20charts%20and%20data%20visualizations%2C%20surrounded%20by%20potted%20green%20plants%2C%20a%20ceramic%20coffee%20mug%2C%20and%20minimalist%20office%20accessories%2C%20soft%20sage%20green%20and%20warm%20terracotta%20accents%20throughout%20the%20room%2C%20scandinavian%20interior%20design%20with%20light%20oak%20flooring%2C%20shallow%20depth%20of%20field%20focused%20on%20the%20screen%2C%20editorial%20interior%20photography%2C%20uplifting%20and%20productive%20atmosphere%2C%20professional%20yet%20cozy%20vibe&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
          alt="BaseTao Spreadsheet modern workspace with data analytics"
          title="BaseTao Spreadsheet workspace"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-6 border border-background-50/20">
            BaseTao Spreadsheet Educational Platform
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            Master BaseTao Spreadsheet:
            <br />
            <span className="text-accent-300">Complete Guides, Tutorials & Expert Reviews</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            Learn BaseTao Spreadsheet from beginner basics to advanced workflows.
            Discover powerful spreadsheet techniques, automation strategies, templates, and productivity methods designed for modern users and businesses.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              basetao spreadsheet
              <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                <i className="ri-external-link-line text-sm"></i>
              </div>
            </a>
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              buy it now
              <div className="w-4 h-4 inline-flex items-center justify-center ml-1.5">
                <i className="ri-shopping-cart-line text-sm"></i>
              </div>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              { icon: 'ri-check-line', text: 'Beginner Friendly' },
              { icon: 'ri-check-line', text: 'Step-by-Step Lessons' },
              { icon: 'ri-check-line', text: 'Updated Resources' },
              { icon: 'ri-check-line', text: 'Expert Insights' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-1.5 text-background-50/80 text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-xs text-accent-300`}></i>
                </div>
                <span className="whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link
              to="/basetao-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              Read the Complete BaseTao Spreadsheet Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}